import { render, staticRenderFns } from "./AddressModal.vue?vue&type=template&id=4f3b38c0"
import script from "./AddressModal.vue?vue&type=script&lang=ts"
export * from "./AddressModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Volumes/Untitled/project/185/185admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f3b38c0')) {
      api.createRecord('4f3b38c0', component.options)
    } else {
      api.reload('4f3b38c0', component.options)
    }
    module.hot.accept("./AddressModal.vue?vue&type=template&id=4f3b38c0", function () {
      api.rerender('4f3b38c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pickup-address/components/AddressModal.vue"
export default component.exports